import { useEffect, useState } from "react";
import {
  getOrganizationStructures,
  updateOrganizationStructure,
} from "../api/organization";
import {
  DEFAULT_ORG_STRUCTURE_ID,
  getOrgStructureById,
  normalizeOrgStructures,
} from "../utils/orgStructures";

let snapshot = {
  structures: normalizeOrgStructures(null),
  selected: getOrgStructureById(DEFAULT_ORG_STRUCTURE_ID),
  loading: true,
  saving: false,
  loaded: false,
  error: "",
};

let inflight = null;
let generation = 0;
const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener(snapshot));
}

function applyCatalog(data, gen) {
  if (gen !== generation) return snapshot;
  const structures = normalizeOrgStructures(data?.structures);
  const selected =
    structures.find((item) => item.id === data?.selectedId) ||
    getOrgStructureById(data?.selectedId || DEFAULT_ORG_STRUCTURE_ID);
  snapshot = {
    ...snapshot,
    structures,
    selected,
    loading: false,
    loaded: true,
    error: "",
  };
  emit();
  return snapshot;
}

export function loadOrganizationStructure() {
  if (snapshot.loaded) return Promise.resolve(snapshot);
  if (inflight) return inflight;

  snapshot = { ...snapshot, loading: true };
  emit();

  const gen = generation;
  inflight = getOrganizationStructures()
    .then((data) => applyCatalog(data, gen))
    .catch(() => {
      if (gen !== generation) return snapshot;
      snapshot = {
        ...snapshot,
        loading: false,
        loaded: false,
        error: "",
      };
      emit();
      return snapshot;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export async function selectOrganizationStructure(structureId) {
  const previous = snapshot;
  generation += 1;
  const gen = generation;
  const selected =
    snapshot.structures.find((item) => item.id === structureId) ||
    getOrgStructureById(structureId);

  snapshot = { ...snapshot, saving: true, error: "", selected };
  emit();

  try {
    const data = await updateOrganizationStructure(structureId);
    snapshot = { ...snapshot, saving: false };
    return applyCatalog(data, gen);
  } catch (err) {
    const message =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      "تعذر حفظ الهيكل التنظيمي";
    snapshot = {
      ...previous,
      saving: false,
      error: Array.isArray(message) ? message.join("\n") : message,
    };
    emit();
    throw err;
  }
}

export function useOrganizationStructure() {
  const [state, setState] = useState(snapshot);

  useEffect(() => {
    listeners.add(setState);
    setState(snapshot);
    loadOrganizationStructure();
    return () => listeners.delete(setState);
  }, []);

  return {
    ...state,
    selectStructure: selectOrganizationStructure,
  };
}
